export enum TABS {
    REQUEST_SUBMISSION_METHODS = 1,
    APPROVAL_TYPE_METHOD,
    APPLICANT_DETAILS,
    GENERAL_DETAILS,
    PRODUCTS,
    REQUEST_DETAILS,
    ATTACHMENTS,
    DECLARATIONS
}
